import { render, staticRenderFns } from "./WelcomePage.vue?vue&type=template&id=0bd29f57&scoped=true"
import script from "./WelcomePage.vue?vue&type=script&lang=js"
export * from "./WelcomePage.vue?vue&type=script&lang=js"
import style0 from "./WelcomePage.vue?vue&type=style&index=0&id=0bd29f57&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd29f57",
  null
  
)

export default component.exports